<template>
    <div v-if="data">
        <div class="page-group-title"><span>收款信息</span></div>
        <table class="info-table MT20" width="100%">
            <tr>
                <th>收款联系人姓名</th>
                <td>{{ data.userName }}</td>
                <th>收款联系人手机</th>
                <td>{{ data.userTelephone }}</td>
            </tr>
            <tr>
                <th>收款联系人邮箱</th>
                <td>{{ data.userEmail }}</td>
                <th>通讯地址</th>
                <td>{{ data.address }}</td>
            </tr>
            <tr>
                <th>银行</th>
                <td>{{ data.bank }}</td>
                <th>开户网点</th>
                <td>{{ data.bankAddress }}</td>
            </tr>
            <tr>
                <th>卡号</th>
                <td>{{ data.bankCardId }}</td>
                <th>账户名</th>
                <td>{{ data.bankAccount }}</td>
            </tr>
            <tr v-if="data.accountType">
                <th>账户性质</th>
                <td>{{ data.accountType == 1 ? '企业' : '个人' }}</td>
                <th>合同编号</th>
                <td>{{ data.contractSn }}</td>
            </tr>
        </table>
        <div v-if="showHistoryAudiList && data.historyAudiList && data.historyAudiList.length > 0" class="MT20">
            <div class="page-group-title"><span>历史结款单</span></div>
            <el-table :data="data.historyAudiList" border style="width: 100%" v-loading="dataLoading" size="small" stripe
                class="MT20">
                <el-table-column prop="applyEndTime" label="销售截止" min-width="150"></el-table-column>
                <el-table-column prop="saleNum" label="销售商品数" min-width="100"></el-table-column>
                <el-table-column prop="saleAmountFormat" label="销售金额"></el-table-column>
                <el-table-column prop="busDiscountFormat" label="商家承担优惠" min-width="100"></el-table-column>
                <el-table-column prop="serviceFeeAmountFormat" label="服务费用"></el-table-column>
                <el-table-column prop="refundAmountStr" label="已结款退款金额" min-width="110"></el-table-column>
                <el-table-column prop="playAmountFormat" label="实际打款金额" min-width="100"></el-table-column>
                <el-table-column prop="status" label="付款状态">
                    <template slot-scope="scope">{{scope.row.status == 1 ? '待打款' : '已打款'}}</template>
                </el-table-column>
                <el-table-column prop="playTime" label="打款时间" min-width="150"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: [String, Number],
            default: ''
        },
        receiptId: {
            type: [String, Number],
            default: ''
        },
        showHistoryAudiList: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            data: null,
            dataLoading: false
        }
    },
    created() {
        this.getData();
    },
    methods: {
        //获取收款信息
        getData() {
            this.dataLoading = true;
            this.$request({
                url: '/goodsReceivablesAudit/info/base',
                params: { payeeUserId: this.id },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = result;
                        this.$emit('update:receiptId', result.id);
                    } else {
                        this.$message.error(msg || "获取收款信息失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取收款信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
    }
}
</script>